import { render, staticRenderFns } from "./BrandVolumeChartTooltip.vue?vue&type=template&id=1139ff5a&scoped=true"
import script from "./BrandVolumeChartTooltip.vue?vue&type=script&lang=js"
export * from "./BrandVolumeChartTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139ff5a",
  null
  
)

export default component.exports